import { BaseElement, ClickElement } from './base-element';
import { ElementType } from './element-type';

export class Modal extends BaseElement {
  header: string | null = null;
  modalOptions: ModalOption[] = [];

  form: boolean = false;

  constructor() {
    super();
    this.elementType = ElementType.modal;
  }
}

export class ModalOption extends ClickElement {
  text: string;
  submit: boolean = false;

  constructor(text: string) {
    super();
    this.text = text;
  }
}
